import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Router } from '@angular/router';
import { isEmpty } from 'lodash-es';
import { environment } from 'src/environments/environment';
import { SessionService, UserRole } from './auth/session.service';
import { LoadingService } from './core/loading-spinner/loading.service';
import { User } from './core/user';
import { ToasterService, ToastStatus } from './core/toaster/toaster.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading$ = this.loadingService.loading$;
  isLoading: boolean = false;

  constructor(
    private readonly loadingService: LoadingService,
    private readonly sessionService: SessionService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private toasterService: ToasterService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(environment.title);
    this.loading$.subscribe({
      next: (value: boolean) => {
        this.isLoading = value;
        this.cdr.detectChanges();
      },
    });
    // setTimeout(() => {
    //   throw new Error("Pagination filter error: date field is not defined");
    // }, 5000);
    // this.sessionService.getMe().subscribe({
    //   next: (user: User) => {
    //     console.log('INIT ROOT PAGE: ', user);
    //     this.sessionService.setUser(user);
    //     console.log("ROUTE APP: ", this.router.url)
    //     if(this.router.url === '/') {
    //       if (user.role == UserRole.agent) {
    //         this.router.navigate(['agent', 'dashboard']);
    //       } else if (
    //         user.role == UserRole.administrator ||
    //         user.role == UserRole.company
    //       ) {
    //         this.router.navigate(['admin', 'dashboard']);
    //       } else {
    //         this.router.navigate(['404']);
    //       }
    //     }
    //   },
    // });

    let user = this.sessionService.getUser();
    if (!isEmpty(user)) {
      if (this.router.url === '/') {
        if (user.role == UserRole.agent) {
          this.router.navigate(['agent', 'homepage']);
        } else if (user.role == UserRole.branch) {
          this.router.navigate(['branch', 'homepage']);
        } else if (user.role == UserRole.administrator) {
          this.router.navigate(['admin', 'signs']);
        } else {
          this.router.navigate(['404']);
        }
      }
    }
  }
}
